module.exports = __webpack_public_path__ + "e606bd43bed083ca684a9f812061d7ad.png";